export default __webpack_public_path__ + "images/0c4a563af0d268fba31578c7e6c9593b.jpeg";